/**
 * Spinner 
 * 
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Spinner.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Spinner = props => {
  const {
    spinner,
    text
  } = props;
  if (!spinner) return null;
  return /*#__PURE__*/_jsx("div", {
    className: "spinner",
    children: /*#__PURE__*/_jsxs("div", {
      className: "inner",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: 'spinner',
        inverse: true,
        className: "fa-spin"
      }), /*#__PURE__*/_jsx("span", {
        className: "text",
        children: text
      })]
    })
  });
};
Spinner.defaultProps = {
  spinner: false,
  text: 'Loading'
};
export default Spinner;